import { render, staticRenderFns } from "./PostLateFees.vue?vue&type=template&id=02cb93dc&scoped=true"
import script from "./PostLateFees.vue?vue&type=script&lang=js"
export * from "./PostLateFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb93dc",
  null
  
)

export default component.exports